export default {
  getTags: state => state.tags,
  getSpecificTag: state => state.tag,
  getTagUse: state => state.tagUse,
}
